import { ArrowDown } from "lucide-react";

const Ecosystem = () => (
  <section
    id="ecosystem"
    data-testid="ecosystem-section"
    className="section-pad bg-[var(--dark)] text-[var(--dark-text)]"
  >
    <div className="container-x">
      <p className="eyebrow eyebrow-dark mb-6">One Ecosystem</p>
      <h2 className="font-display max-w-2xl text-4xl leading-[1.1] tracking-tight sm:text-5xl">
        Two sides of the same fit intelligence.
      </h2>

      <div className="mt-16 grid items-stretch gap-6 lg:grid-cols-[1fr_auto_1.2fr_auto_1fr]">
        <article
          data-testid="ecosystem-consumer-card"
          className="rounded-md border border-[var(--dark-line)] bg-[var(--dark-card)] p-8"
        >
          <p className="text-xs uppercase tracking-[0.2em] text-[var(--dark-muted)]">Consumer App</p>
          <h3 className="font-display mt-4 text-2xl">Your fit, your history</h3>
          <p className="mt-3 text-sm leading-relaxed text-[var(--dark-muted)]">
            Fit profiles + real-world fit experiences
          </p>
        </article>

        <div className="flex items-center justify-center lg:flex-col" aria-hidden="true">
          <ArrowDown className="text-[var(--dark-muted)] lg:-rotate-90" size={20} />
        </div>

        <article
          data-testid="ecosystem-intelligence-card"
          className="rounded-md border border-[var(--rust)]/50 bg-[var(--dark-card)] p-8"
        >
          <p className="text-xs uppercase tracking-[0.2em] text-[#d08a63]">
            Crowdsourced Fit Intelligence
          </p>
          <h3 className="font-display mt-4 text-2xl">Shared fit knowledge</h3>
          <p className="mt-3 text-sm leading-relaxed text-[var(--dark-muted)]">
            Shared fit knowledge built from real-world experiences contributed
            by shoppers.
          </p>
        </article>

        <div className="flex items-center justify-center lg:flex-col" aria-hidden="true">
          <ArrowDown className="text-[var(--dark-muted)] lg:-rotate-90" size={20} />
        </div>

        <article
          data-testid="ecosystem-plugin-card"
          className="rounded-md border border-[var(--dark-line)] bg-[var(--dark-card)] p-8"
        >
          <p className="text-xs uppercase tracking-[0.2em] text-[var(--dark-muted)]">Ecommerce Plugin</p>
          <h3 className="font-display mt-4 text-2xl">Fit intelligence at the point of sale</h3>
          <p className="mt-3 text-sm leading-relaxed text-[var(--dark-muted)]">
            Size recommendations + feedback loop
          </p>
        </article>
      </div>

      <p className="mt-12 max-w-xl text-sm leading-relaxed text-[var(--dark-muted)]">
        Fit records, recommendations and feedback connect the consumer and
        retailer sides of the ecosystem.
      </p>
    </div>
  </section>
);

export default Ecosystem;
